import { Button } from "@/components/button";

interface BillingErrorStateProps {
  readonly message: string;
  readonly onRetry: () => void;
}

export function BillingErrorState({
  message,
  onRetry,
}: BillingErrorStateProps) {
  return (
    <div className="flex flex-col items-start gap-md p-xl">
      <p className="text-sm text-text-secondary">{message}</p>
      <Button onPress={onRetry} size="sm" variant="secondary">
        Retry
      </Button>
    </div>
  );
}
